import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "icon-cart" }
const _hoisted_2 = {
  key: 0,
  class: "icon-cart__counter",
  style: {"background":"#E42313"}
}

import { computed } from 'vue';
import { useStore } from 'vuex';
import { formatNumber } from '@/helpers';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faShoppingCart } from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'IconCart',
  setup(__props) {

library.add(faShoppingCart);

const store = useStore();
const cartItemsCount = computed(() => store.getters['cart/countAll']);

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createVNode(_component_FontAwesomeIcon, { icon: "fa-light fa-shopping-cart" }),
    (cartItemsCount.value > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(formatNumber)(cartItemsCount.value, 0)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})